/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Producer_UpdatedInputs */

const en_producer_updated = /** @type {(inputs: Producer_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Producer updated`)
};

const es_producer_updated = /** @type {(inputs: Producer_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Productor actualizado`)
};

/**
* | output |
* | --- |
* | "Producer updated" |
*
* @param {Producer_UpdatedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const producer_updated = /** @type {((inputs?: Producer_UpdatedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Producer_UpdatedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_producer_updated(inputs)
	return es_producer_updated(inputs)
});